import React, {useEffect, useState} from 'react';
import './SettingsModal.css';


const IconSelector = ({ value, onChange, icons }) => {
    const [isOpen, setIsOpen] = useState(false);
    const iconOptions = [
        { path: '/assets/icons/openai-Wym7AITM.webp', label: 'GPT-4' },
        { path: '/assets/icons/anthropic-KpkKHV99.webp', label: 'Claude' },
        { path: '/assets/icons/gemini-BHNSVL96.webp', label: 'Gemini' },
        { path: '/assets/icons/qwen.png', label: '千问' },
        { path: '/assets/icons/mistra.png', label: 'Mistral' },
        { path: '/assets/icons/grok.png', label: 'Grok' },
        { path: '/assets/icons/doubao.png', label: '豆包' },
        { path: '/assets/icons/wenxin.png', label: '文心一言' },
        { path: '/assets/icons/deepseek.ico', label: 'Deepseek' },
        { path: '/assets/icons/keemi.ico', label: 'Kimi' },
        { path: '/assets/icons/zhipu.svg', label: '智谱' },
        { path: '/assets/icons/spark-icon.ico', label: '讯飞星火' },
        { path: '/assets/icons/llama-CkjhBMGW.webp', label: 'LLAMA' }
    ];

    return (
        <div className="IconSelector">
            <div className="IconSelectorTrigger" onClick={() => setIsOpen(!isOpen)}>
                {value ? (
                    <img src={value} alt="Selected Icon" className="SelectedIcon" />
                ) : (
                    <span>选择图标</span>
                )}
            </div>
            {isOpen && (
                <div className="IconSelectorMenu">
                    {iconOptions.map((icon) => (
                        <div
                            key={icon.path}
                            className="IconSelectorItem"
                            onClick={() => {
                                onChange(icon.path);
                                setIsOpen(false);
                            }}
                        >
                            <img src={icon.path} alt={icon.label} title={icon.label} />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};


const SettingsModal = ({onClose}) => {
    const [activeTab, setActiveTab] = useState('api'); // 当前 Tab 状态
    const [apiSources, setApiSources] = useState([]); // API 配置
    const [modelConfigs, setModelConfigs] = useState([]); // 模型配置

    // 加载本地存储的配置
    useEffect(() => {
        const savedApiSources = JSON.parse(localStorage.getItem('apiSources')) || [];
        const savedModelConfigs = JSON.parse(localStorage.getItem('modelConfigs')) || [];
        setApiSources(savedApiSources);
        setModelConfigs(savedModelConfigs);
    }, []);

    // 保存到本地存储
    const saveToLocalStorage = () => {
        localStorage.setItem('apiSources', JSON.stringify(apiSources));
        localStorage.setItem('modelConfigs', JSON.stringify(modelConfigs));
        alert('配置已保存到本地存储！');
    };

    const handleAddApiSource = () => {
        setApiSources([...apiSources, {name: '', api_key: '', api_base: ''}]);
    };

    const handleAddModelConfig = () => {
        setModelConfigs([...modelConfigs, {value: '', apiName: '', label: '', icon: ''}]);
    };

    return (
        <div className="SettingsModal">
            <div className="SettingsHeader">
                <h2>设置</h2>
                <button onClick={onClose}>✖</button>
            </div>
            <div className="SettingsTabs">
                <button
                    className={activeTab === 'api' ? 'active' : ''}
                    onClick={() => setActiveTab('api')}
                >
                    API 源
                </button>
                <button
                    className={activeTab === 'model' ? 'active' : ''}
                    onClick={() => setActiveTab('model')}
                >
                    模型配置
                </button>
            </div>
            <div className="SettingsContent">
                {activeTab === 'api' && (
                    <div className="ApiSourceTab">
                        <h3>配置 API 源</h3>
                        {apiSources.map((api, index) => (
                            <div key={index} className="ConfigCard">
                                <div className="ConfigCardContent">
                                    <input
                                        placeholder="API 名称"
                                        value={api.name}
                                        onChange={(e) => {
                                            const newApiSources = [...apiSources];
                                            newApiSources[index].name = e.target.value;
                                            setApiSources(newApiSources);
                                        }}
                                    />
                                    <input
                                        placeholder="API Key"
                                        value={api.api_key}
                                        onChange={(e) => {
                                            const newApiSources = [...apiSources];
                                            newApiSources[index].api_key = e.target.value;
                                            setApiSources(newApiSources);
                                        }}
                                    />
                                    <input
                                        placeholder="API Base"
                                        value={api.api_base}
                                        onChange={(e) => {
                                            const newApiSources = [...apiSources];
                                            newApiSources[index].api_base = e.target.value;
                                            setApiSources(newApiSources);
                                        }}
                                    />
                                </div>
                                <div className="ConfigCardActions">
                                    <span
                                        className="icon icon-delete"
                                        title="删除配置"
                                        onClick={() => setApiSources(apiSources.filter((_, i) => i !== index))}
                                    >
                                        ❌
                                    </span>
                                </div>
                            </div>
                        ))}
                        <span className="icon icon-add" onClick={handleAddApiSource} title="添加新 API 源">➕</span>
                    </div>
                )}
                {activeTab === 'model' && (
                    <div className="ModelConfigTab">
                        <h3>配置模型</h3>
                        {modelConfigs.map((model, index) => (
                            <div key={index} className="ConfigCard">
                                <div className="ConfigCardContent">
                                    <input
                                        placeholder="模型名称"
                                        value={model.value}
                                        onChange={(e) => {
                                            const newModelConfigs = [...modelConfigs];
                                            newModelConfigs[index].value = e.target.value;
                                            setModelConfigs(newModelConfigs);
                                        }}
                                    />
                                    <select
                                        value={model.apiName}
                                        onChange={(e) => {
                                            const newModelConfigs = [...modelConfigs];
                                            newModelConfigs[index].apiName = e.target.value;
                                            setModelConfigs(newModelConfigs);
                                        }}
                                    >
                                        <option value="">选择 API 源</option>
                                        {apiSources.map((api, i) => (
                                            <option key={i} value={api.name}>
                                                {api.name}
                                            </option>
                                        ))}
                                    </select>
                                    <input
                                        placeholder="可见名称"
                                        value={model.label}
                                        onChange={(e) => {
                                            const newModelConfigs = [...modelConfigs];
                                            newModelConfigs[index].label = e.target.value;
                                            setModelConfigs(newModelConfigs);
                                        }}
                                    />
                                    <IconSelector
                                        value={model.icon}
                                        onChange={(iconPath) => {
                                            const newConfigs = [...modelConfigs];
                                            newConfigs[index].icon = iconPath;
                                            setModelConfigs(newConfigs);
                                        }}
                                    />
                                </div>
                                <div className="ConfigCardActions">
                                    <span
                                        className="icon icon-delete"
                                        title="删除配置"
                                        onClick={() => setModelConfigs(modelConfigs.filter((_, i) => i !== index))}
                                    >
                                        ❌
                                    </span>
                                </div>
                            </div>
                        ))}
                        <span className="icon icon-add" onClick={handleAddModelConfig} title="添加新模型配置">➕</span>
                    </div>
                )}
            </div>
            <div className="SettingsFooter">
                <button onClick={saveToLocalStorage}>保存设置</button>
            </div>
        </div>
    );
};

export default SettingsModal;

